import React from 'react';
import PropTypes from 'prop-types';
import {Grid, IconButton} from "@mui/material";
import StyledLine from "../../../../components/List/components/StyledLine";
import ActiveButton from "./ActiveButton";
import TrashIcon from "../../../../components/icons/TrashIcon";
import EditIcon from "../../../../components/icons/EditIcon";
import moment from "moment";
import {greyishBlue500} from "../../../../assets/jss/main";
import BeatLoaderRegular from "../../../../components/loaders/BeatLoaderRegular";

ModelItem.propTypes = {
    missionModel: PropTypes.object.isRequired,
    loading: PropTypes.bool.isRequired,
    setLoading: PropTypes.func.isRequired,
    handlePatchModel: PropTypes.func.isRequired,
    handleEditMissionModel: PropTypes.func.isRequired,
    handleDeleteMissionModel: PropTypes.func.isRequired
};

function ModelItem({missionModel, loading, setLoading, handlePatchModel, handleEditMissionModel, handleDeleteMissionModel}) {

    return (
        <>
            <Grid
                container
                key={missionModel.id}
                sx={{padding: '8px 0'}}
            >
                <StyledLine
                    justifyContent={"space-between"}
                    alignItems={'center'}
                >
                    <Grid
                        item
                        container
                        xs={6}
                        columnSpacing={2}
                        alignItems={'center'}
                    >
                        <Grid item>
                            {missionModel.name}
                        </Grid>
                    </Grid>
                    <Grid
                        container
                        xs={6}
                        columnSpacing={2}
                        justifyContent={"end"}
                    >
                        <Grid
                            container
                            xs={3}
                            justifyContent={"start"}
                        >
                            <ActiveButton
                                missionModel={missionModel}
                                onClick={handlePatchModel}
                                loading={loading}
                                setLoading={setLoading}
                            />
                        </Grid>

                        <Grid
                            container
                            xs={3}
                            justifyContent={"center"}
                            alignItems={"center"}
                        >
                            <Grid item sx={{fontWeight: "bold"}}>
                                {moment(missionModel.createdAt || missionModel.updatedAt).format('DD/MM/YYYY') || " - "}
                            </Grid>
                        </Grid>

                        <Grid
                            container
                            xs={2}
                            justifyContent={"end"}
                        >
                            <Grid item sx={{width: '80px'}}>
                                {loading && (
                                    <Grid container justifyContent={"end"}>
                                        <BeatLoaderRegular loading={true} size={10} />
                                    </Grid>
                                )}

                                {!loading && (
                                    <Grid item container justifyContent={"end"}>
                                        <IconButton onMouseDown={() => {
                                            handleEditMissionModel(missionModel)
                                        }}>
                                            <EditIcon size={16}/>
                                        </IconButton>
                                        <IconButton onMouseDown={() => {
                                            handleDeleteMissionModel(missionModel)
                                        }}>
                                            <TrashIcon color={greyishBlue500} size={18}/>
                                        </IconButton>
                                    </Grid>
                                )}
                            </Grid>
                        </Grid>
                    </Grid>
                </StyledLine>
            </Grid>
        </>
    );
}

export default ModelItem;